import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// Components
import Theme from '../assets/Theme';
import Confirmacion from '../containers/Confirmacion/index';
import Autorizacion from '../containers/Autorizacion/index';
import ErrorConfirmacion from '../components/atoms/ErrorConfirmacion/index';
import ErrorAutorizacion from '../components/atoms/ErrorAutorizacion/index';

// Routing system.
const App = () => (
  <Theme>
    <Helmet>
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Ubuntu:wght@300;400;700&display=swap"
      />
    </Helmet>
    <BrowserRouter>
      <div className="container-passCoopeuch">
        <Switch>
          <Route exact path="/login" component={Confirmacion} />
          <Route path="/autorizacion" component={Autorizacion} />
          <Route path="/error/confirmacion" component={ErrorConfirmacion} />    
          <Route path="/error/autorizacion" component={ErrorAutorizacion} />
        </Switch>
      </div>
    </BrowserRouter>
  </Theme>
);

export default App;
